<template>
  <div>
    <div class="fzlc">
      <div class="contentBox w">
        <div class="contentStitle">development history</div>
        <div class="contentTitle">发展历程</div>
        <div class="contentLine">
          <span class="lineLeft"></span>
          <span class="lineMiddle"></span>
          <span class="lineRight"></span>
        </div>
        <div class="itemBox">
          <div class="bgimg">
            <img :src="src.line" alt />
          </div>
          <div class="item child_1">
            <div class="itemIcon"></div>
            <div class="itemTitle">2010年5月</div>
            <div class="itemText">云久鸿劳务派遣公司成立</div>
          </div>
          <div class="item child_2">
            <div class="itemText text_bottom">云久鸿正式成为富士康的合格人才供应商</div>
            <div class="itemText">
              累积沉淀期：公司经历了六年的扎根，专注为客户提供用工管理、控制人力成本、合理减少用工风险，效率和服务赢得了市场的认可，云久鸿成为富士康的人力输送优质供应商。
            </div>
            <div class="itemTitle">2016年8月</div>
            <div class="itemIcon"></div>
          </div>
          <div class="item child_3">
            <div class="itemIcon"></div>
            <div class="itemTitle">2016年12月</div>
            <div class="itemText">深圳市云久鸿人力资源有限公司成立</div>
          </div>
          <div class="item child_4">
            <div class="itemText text_bottom">云久鸿劳务派遣公司成立</div>
            <div class="itemText">
              云久鸿正式搭建网络招聘系统，成立网络招聘部，从创始三人团队迅速扩张至50人，每天输送量达300人次。
            </div>
            <div class="itemTitle">2017年8月</div>
            <div class="itemIcon"></div>
          </div>
          <div class="item child_5">
            <div class="itemIcon"></div>
            <div class="itemTitle">2018年</div>
            <div class="itemText text_bottom">派遣员工年在职人数突破5万人</div>
            <div class="itemText">
              蓬勃发展期:云久鸿劳务派遣业务发展迅速，服务范围主要集中在深圳周边地区，涉及电子、电器、物业、印刷、五金等多个行业，成为深圳劳务派遣的佼佼者。
            </div>
          </div>
          <div class="item child_6">
            <div class="itemIcon"></div>
            <div class="itemTitle">2019年</div>
            <div class="itemText">单日输送达2000人次</div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobile_fzlc">
      <div class="mobile_contentBox">
        <div class="contentStitle">development history</div>
        <div class="contentTitle">发展历程</div>
        <div class="line"></div>
        <div class="item">
          <div class="item_left"></div>
          <div class="item_middle">2010年5月</div>
          <div class="item_right">
            <div class="item_title">云久鸿劳务派遣公司成立</div>
          </div>
        </div>
        <div class="item">
          <div class="item_left"></div>
          <div class="item_middle">2016年8月</div>
          <div class="item_right">
            <div class="item_title">云久鸿正式成为富士康的合格人才供应商</div>
            <div>
              <span class="item_title">累积沉淀期</span>
              ：公司经历了六年的扎根，专注为客户提供用工管理、控制人力成本、合理减少用工风险，效率和服务赢得了市场的认可，云久鸿成为富士康的人力输送优质供应商。
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_left"></div>
          <div class="item_middle">2016年12月</div>
          <div class="item_right">
            <div class="item_title">深圳市云久鸿人力资源有限公司成立</div>
            <div>
              <span class="item_title"> 步入正轨期 </span>
              ：云久鸿创立人力资源公司，从此进入合理化、规范化的经营道路，也为公司化、多元化发展打下坚实的基础。面对逐渐增大的行业竞争压力，云久鸿子公司的业务不断扩大，企业规模快速增长、壮大。
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_left"></div>
          <div class="item_middle">2017年8月</div>
          <div class="item_right">
            <div class="item_title">云久鸿劳务派遣公司成立</div>
            <div>
              <span class="item_title"> 内部整合期 </span>
              ：云久鸿正式搭建网络招聘系统，成立网络招聘部，从创始三人团队迅速扩张至50人，每天输送量达300人次。
            </div>
          </div>
        </div>
        <div class="item">
          <div class="item_left"></div>
          <div class="item_middle">2018年</div>
          <div class="item_right">
            <div class="item_title">派遣员工年在职人数突破5万人</div>
            <div>
              <span class="item_title"> 蓬勃发展期</span>
              ：云久鸿劳务派遣业务发展迅速，服务范围主要集中在深圳周边地区，涉及电子、电器、物业、印刷、五金等多个行业，成为深圳劳务派遣的佼佼者。
            </div>
          </div>
        </div>

        <div class="item">
          <div class="item_left"></div>
          <div class="item_middle">2019年</div>
          <div class="item_right">
            <div class="item_title">单日输送达2000人次</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import src from "../../../utils/assets";
export default {
  data() {
    return {
      src: src,
    };
  },
};
</script>

<style lang="less">
@media screen and (max-width: 999px) {
  .fzlc {
    display: none;
  }
  .mobile_fzlc {
    .mobile_contentBox {
      .line {
        width: 1px;
        height: 480px;
        border: 1px solid #da261d;
        position: absolute;
        left: 25px;
      }
      .item {
        display: flex;
        justify-content: space-between;
        padding: 0 20px;
        margin: 20px 0;
        .item_left {
          width: 12px;
          height: 12px;
          background: #da261d;
          border-radius: 50%;
        }
        .item_middle {
          font-size: 12px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #da261d;
          // line-height: 60px;
        }
        .item_right {
          width: 70%;
          text-align: left;
          .item_title {
            font-weight: 700;
            margin-bottom: 10px;
          }
        }
      }
    }
  }
}
@media screen and (min-width: 1000px) {
  .mobile_fzlc {
    display: none;
  }
  .fzlc {
    margin-top: -20px;
    margin-bottom: -10px;
    width: 100%;
    background-image: url("https://yunjiuhong.oss-cn-zhangjiakou.aliyuncs.com/website/2020/12/30/4gCcto55IR0Fn8vtvBIv8UT0ar4EejdiAEKleUIA.png");
    .itemBox {
      padding: 200px 0;
      position: relative;
      .bgimg {
        width: 1000px;
        margin: 0 auto;
        img {
          width: 100%;
        }
      }
      .item {
        position: absolute;
        width: 220px;
        text-align: center;
        .itemTitle {
          font-size: 32px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #da261d;
          line-height: 60px;
        }
        .itemText {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #ffffff;
        }
        .itemIcon {
          width: 16px;
          height: 16px;
          background: #ffffff;
          border-radius: 50%;
          margin: 0 auto;
        }
        .text_bottom {
          margin-bottom: 20px;
        }
      }
      .child_1 {
        top: 530px;
        left: -12px;
      }
      .child_2 {
        top: 118px;
        left: 150px;
      }
      .child_3 {
        top: 360px;
        left: 345px;
      }
      .child_4 {
        top: 85px;
        left: 485px;
      }
      .child_5 {
        top: 275px;
        left: 740px;
      }
      .child_6 {
        top: 193px;
        left: 990px;
      }
    }
  }
}
</style>
